export const hasToken = () => !!getToken()
export const getToken = () => localStorage.getItem('token')
